import { IGetProjetoInformacoesByIdUseCase } from "../../../presentation/useCases/read/get_projeto_informacoes_by_id_use_case";
import { GetProjetoInformacoesByIdRequestModel, ProjetoInformacoesGetByIdModel } from "../../models/projeto_informacoes";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetProjetoInformacoesByIdUseCase
 */

export class GetProjetoInformacoesByIdUseCase implements IGetProjetoInformacoesByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async getProjetoInformacoesById(request: GetProjetoInformacoesByIdRequestModel): Promise<ProjetoInformacoesGetByIdModel> {
    return await this.repository.getProjetoInformacoesById(request);
  }
}
